import { Action } from '@interstate/components/Action';
import { DetailsIcon } from '@interstate/components/Icons';

import { ManualTemplatesListSlideOut } from './ManualTemplatesListSlideOut';
import { useManualTemplatesList } from './useManualTemplatesList';

export const OpenManualTemplatesListButton = () => {
    const { isOpen, isDisabled, open, close } = useManualTemplatesList();

    return (
        <>
            <Action
                actionIcon={{ icon: <DetailsIcon />, start: true }}
                id="toggle-manual-template-list-drawer-button"
                data-testid="toggle-manual-template-list-drawer-button"
                onClick={open}
                size="lg"
                disabled={isDisabled}
            />
            <ManualTemplatesListSlideOut isOpen={isOpen} onHide={close} />
        </>
    );
};
